export const ALLOWED_PARAMS = [
  'cart',
  'package',
  'utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'referrer',
  'gclid',
  'gad_source',
  'gbraid',
  'gad_campaignid',
  'gdmcid',
  'gtm_debug',
  'li_ed',
  'li_giant',
  'li_fat_id',
  'aclk',
  'msclkid',
  'twclid',
  'fbclid',
  'customclid',
] as const;
